import classNames from 'classnames';
import { useFormContext, useWatch } from 'react-hook-form';

import FieldError from 'components/form/FieldError';

import { ITextInputProps } from './interfaces';

export const TextInput = ({
  name,
  label,
  type,
  additionalClassName,
}: ITextInputProps): JSX.Element => {
  const {
    register,
    formState: { errors },
  } = useFormContext();

  const currentValue = useWatch({
    name,
  });

  const className = classNames(
    'text-input__input',
    {
      'text-input__input--filled': !!currentValue,
      'text-input__input--error': !!errors?.[name]?.message,
    },
    additionalClassName
  );

  return (
    <div className={'text-input'}>
      <input type={type} id={name} className={className} {...register(name)} />
      <label htmlFor={name} className={'text-input__label'}>
        {label}
      </label>
      <div className={'text-input__line'} />
      <FieldError
        name={name}
        errors={errors}
        additionalClassName={'contact-form__error--text-input'}
      />
    </div>
  );
};
